import React from 'react'
import { Link } from 'react-router-dom';

const ViewClinicalStaff = () => {
  return (
    <main id="main" className="main">
		{/* Page Title Section */}
		<div className="pagetitle clearfix">
			<div className="float-start">
			  <h1>View Clinical Staff Info</h1>
				<nav>
					<ol className="breadcrumb">
					  <li className="breadcrumb-item"><Link to="/admin/dashboard">Home</Link></li>
					  <li className="breadcrumb-item"><Link to="hospital.html">Clinical Staff</Link></li>
					  <li className="breadcrumb-item active">View Clinical Staff Info </li>
					</ol>
				</nav>
			</div>
			<div className="float-end mt-2 me-1">
				<Link to="#" onClick="window.history.back();" className="backIcon"><i className="iconly-Bold-ArrowLeftSquare"></i></Link>
			</div>{/* End Buttons */}
		</div>
		{/* End Page Title Section */}
		{/* Page Content Section */}
		<section>
		<div className="row">
			{/*ProfileImg*/}
			<div className="col-lg-4">
				<div className="card profile-img">
					<div className="card-body">
						<div className="top-bar">
							<img className="img-fluid d-block mx-auto" src="/assets/img/cl-staff-img1.png" />
							<h1>Deepika Devi</h1>
							<h6 className="text-tmBlue">Staff Nursing</h6>
						</div>
						<div className="center-bar clearfix">
							<div className="d-flex align-items-center mb-4">
								<div className="info-icon">
									<i className="iconly-Bold-Send"></i>
								</div>
								<div className="ms-2">
									<p className="mb-0 text-tmBlue">Email</p>
									<Link to="#" className="h6 text-dark">emailaddrees@mail.com</Link>
								</div>
							</div>
							<div className="d-flex align-items-center mb-4">
								<div className="info-icon">
									<i className="iconly-Bold-Calling"></i>
								</div>
								<div className="ms-2">
									<p className="mb-0 text-tmBlue">Phone</p>
									<Link className="h6 text-dark">+91 123 456 7890</Link>
								</div>
							</div>
						</div>
						<div className="d-grid mt-4">
							<Link to="/admin/add-clinical-staff" className="btn btn-block btn-outline-tmBlue">
								<i className="ri-edit-2-fill align-middle"></i> Edit Profile
							</Link>
						</div>
					</div>
				</div>
            </div>
			{/*ProfileInfo*/}
			<div className="col-lg-8">
				<div className="card profile-info">
					<div className="card-body pt-4">
						<div className="row">
							<div className="col-xxl-12 px-3 mb-5">
								<div className="secTitle">
									<h1>Hospital Info</h1>
								</div>
								<div className="secContent">
									<div className="table-responsive">	
										<table className="table table-borderless theme-table">
											<thead>
											  <tr>
												<th scope="col">Hospital</th>
												<th scope="col">Working Days</th>
												<th scope="col">Working Hours</th>
												<th scope="col" className="text-center">Action</th>
											  </tr>
											</thead>
											<tbody>
												<tr>
													<td scope="row" className="prty-td">
														<Link to="hospital-view-info.html">
															<h5 className="table-title">Best Care Hospital</h5>
														</Link>
													</td>					
													<td>Mon - Wed</td>				
													<td>11:30 AM to 02:30 PM</td>				
													<td className="text-center fw-normal">
														<Link to="#" className="text-warning"><i className="ri-edit-2-line align-middle h6 mr-2"></i> </Link>
														<Link to="#" className="text-danger"><i className="ri-delete-bin-7-line align-middle h6"></i></Link>
													</td>
												</tr>
												<tr>
													<td scope="row" className="prty-td">
														<Link to="#">
															<h5 className="table-title">Healthy Kids Hospital</h5>
														</Link>
													</td>					
													<td>Thr - Fri</td>				
													<td>04:30 PM to 06:30 PM</td>				
													<td className="text-center fw-normal">
														<Link to="#" className="text-warning"><i className="ri-edit-2-line align-middle h6 mr-2"></i> </Link>
														<Link to="#" className="text-danger"><i className="ri-delete-bin-7-line align-middle h6"></i></Link>
													</td>
												</tr>
												<tr>
													<td scope="row" className="prty-td">
														<Link to="#">
															<h5 className="table-title">ABCD Children Hospital</h5>
														</Link>
													</td>						
													<td>Sat - Sun</td>				
													<td>08:30 AM to 10:30 PM</td>				
													<td className="text-center fw-normal">
														<Link to="#" className="text-warning"><i className="ri-edit-2-line align-middle h6 mr-2"></i> </Link>
														<Link to="#" className="text-danger"><i className="ri-delete-bin-7-line align-middle h6"></i></Link>
													</td>
												</tr>
											</tbody>
									    </table>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
            </div>
        </div>
    </section>
		{/* End Page Content Section */}
	</main>
  )
}

export default ViewClinicalStaff
